import { useCallback, useState } from 'react';

import { AxiosResponse } from 'axios';

import { DETAILS_DATA_TYPES } from 'store/details/utils/constants.ts';
import isBtvProgrammesResponse from 'store/details/utils/isBtvProgrammesResponse.ts';
import {
    BTVProgrammesResponse,
    ResponseError,
    SeasonsListResponse,
    VodResponse,
} from 'store/railsBuilder/reducer.types.ts';

import { getSettledResponseData } from 'utils/axios/nagra/utils.ts';

import { noSeasonName } from '../constants.ts';
import { SeasonListItem } from '../types.ts';
import isSeasonsListResponse from '../utils/isSeasonsListResponse.ts';
import requestNoSeasonEpisodesData from '../utils/requestNoSeasonEpisodesData.ts';
import requestSeasonsNumbersData from '../utils/requestSeasonsNumbersData.ts';

function useProgramSeasons() {
    const [programSeasons, setProgramSeasons] = useState<SeasonListItem[]>([]);

    const handleLoadBTVProgramSeasonsList = useCallback(
        async (_seriesId: string, _channelId: string | undefined) => {
            const [
                programsSeasonsListSettlesResponse,
                noSeasosEpisodesSettledResponse,
            ] = await Promise.allSettled([
                requestSeasonsNumbersData(
                    DETAILS_DATA_TYPES.PROGRAM,
                    _seriesId,
                    _channelId,
                ),
                requestNoSeasonEpisodesData(
                    DETAILS_DATA_TYPES.PROGRAM,
                    _seriesId,
                    _channelId,
                    undefined,
                    0,
                ),
            ]);

            const programsSeasonsListResponse = getSettledResponseData<
                AxiosResponse<SeasonsListResponse | ResponseError> | undefined
            >(programsSeasonsListSettlesResponse);
            const noSeasonEpisodesResponse = getSettledResponseData<
                | AxiosResponse<
                      BTVProgrammesResponse | VodResponse | ResponseError
                  >
                | undefined
            >(noSeasosEpisodesSettledResponse);

            if (isSeasonsListResponse(programsSeasonsListResponse)) {
                const seasonsList =
                    programsSeasonsListResponse.data.values.map<SeasonListItem>(
                        (s) => ({
                            seasonId: s,
                            seasonNumber: Number(s),
                        }),
                    );

                if (
                    isBtvProgrammesResponse(noSeasonEpisodesResponse) &&
                    noSeasonEpisodesResponse.data.total_records > 0
                ) {
                    seasonsList.push({
                        seasonId: noSeasonName,
                        seasonNumber: noSeasonName,
                    });
                }

                setProgramSeasons(seasonsList);

                return seasonsList;
            }

            return [];
        },
        [],
    );

    return {
        seasons: programSeasons,
        onLoadSeasons: handleLoadBTVProgramSeasonsList,
    };
}

export default useProgramSeasons;
